import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import cuentasPorCobrarMailPdf from "../../../../Pdf/cuentasPorCobrarMailPdf"; 
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalMandarEstadoCuenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarTodo();
    }
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "recordatoriosProgramados/obtenerDatosPdfEstadoCuenta",
        {
          clienteId: this.props.clienteId,
          empresaId: this.props.empresaId,
          sinRemisiones: this.props.sinRemisiones || false,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data?.correosEnvio?.length > 0 && this.formRef.current) {
            this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio });
          }
          
          const pdf = pdfMake.createPdf(cuentasPorCobrarMailPdf(res.data.datosCxCCliente));
          
          this.setState(
            {
              loading: false,
              pdf: pdf,
            },
            () => {
              pdf.open({}, window.frames["estadoCuentaPdf"]);
            }
          );
        } else {
            message.warning(res.data.message || "Error al cargar previsualización");
            this.setState({ loading: false });
        }
      })
      .catch((error) => {
          console.error(error);
          this.setState({ loading: false });
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values?.correosEnvio?.length > 0) {
      this.setState({ loading: true });
      axios
        .post(
          "recordatoriosProgramados/enviarRecordatorioIndividual",
          {
              ...values,
              clienteId: this.props.clienteId,
              empresaId: this.props.empresaId,
              usuarioId: this.props.usuarioId,
              sinRemisiones: this.props.sinRemisiones || false,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Estado de cuenta enviado correctamente.");
            this.cerrarMandarCorreo();
          } else {
            message.warning(res.data.message || "Sucedio un error y no se pudo enviar");
          }
        })
        .catch(err => {
            this.setState({ loading: false });
            message.error("Error de conexión al enviar el correo.");
        });
    } else {
      message.info("Proporcione al menos un correo de envío");
    }
  }

  cerrarMandarCorreo = () => {
    this.props.onCancel();
    if (this.formRef.current) {
        this.formRef.current.resetFields();
    }
  }

  render() {
    return (
      <ModalItem
        title={this.props.sinRemisiones ? "Vista previa - Estado de Cuenta (sin remisiones)" : "Vista previa - Estado de Cuenta"}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarMandarCorreo}
        paddingTop
        zIndex={this.props.zIndex}
      >
        <Form
          ref={this.formRef}
          name="mandarEstadoCuenta"
          layout
          width={700}
          onCancel={this.cerrarMandarCorreo}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed.bind(this)}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: '' }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label='Correo'
                        required
                        margin
                        email
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarMandarCorreo}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title={"estadoCuenta"}
          style={{ width: "100%", height: "100vh" }}
          id="estadoCuentaPdf"
          name="estadoCuentaPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,
  };
};

export default connect(mapStateToProps)(ModalMandarEstadoCuenta);